import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_like",
  "use": "svg_like-usage",
  "viewBox": "0 0 31 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 31 28\" id=\"svg_like\"><path d=\"M6 27.714H0v-17h6v17Zm25-15.243-.014.111.014 2.66c0 .361-.071.694-.2 1.012l-4.314 9.77c-.429.997-1.443 1.69-2.629 1.69H11c-1.571 0-2.857-1.247-2.857-2.771V11.086c0-.762.314-1.455.843-1.954L18.386 0 19.9 1.455c.386.374.629.9.629 1.469l-.043.443L19.129 9.7h9.014C29.714 9.7 31 10.947 31 12.471Z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol